const timeFormat = new Intl.DateTimeFormat("de-DE", {
  hour: "2-digit",
  minute: "2-digit",
});

const dayFormat = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
});

const sameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const offlineBannerText = (lastLoadedAt, now = Date.now()) => {
  if (!Number.isFinite(lastLoadedAt)) return "Offline";
  const loaded = new Date(lastLoadedAt);
  const time = timeFormat.format(loaded);
  if (sameDay(loaded, new Date(now))) {
    return `Offline – zuletzt aktualisiert um ${time}`;
  }
  return `Offline – zuletzt aktualisiert am ${dayFormat.format(loaded)} um ${time}`;
};
